module.exports = __webpack_public_path__ + "img/qr-scaner-border.6219f24d.png";